import React, {Component} from 'react';
import _ from "i18n";
import {connect} from "react-redux";
import {
  setEventStatsSearchFilter
} from "../../../actions/actions.js";
import {debounce} from 'lodash';

class EventStatsSearchFilter extends Component {

  constructor(props) {
    super(props);

    this.state = {
      search: '',
    };
  }

  handleSearch = (value) => {
    this.setState({search: value});
    debounce(this.props.setEventStatsSearchFilter(value), 500);
  };

  render() {
    return <div className={'event-filter-search'}>
      <img src="/img/icons/search.svg" className="event-stats-hr"/>
      <input
        value={this.state.search}
        placeholder={_("search")}
        onChange={({target: {value}}) => this.handleSearch(value)}
      />
    </div>;
  }
}


const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setEventStatsSearchFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventStatsSearchFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/SearchFilter.js